import { useGetOrgDocuments } from 'api/EventCreation/creationStep5'
import Spinner from 'components/Spinner'
import React, { useEffect } from 'react'
import { OrgDocumentResp } from 'types/event/eventStep5'
import SelectDocument from './SelectDocument'
import EmptyData from 'components/global/EmptyData'

interface DocumentContentProps {
  organizationId: string
  referenceId: string
  reference: 'event' | 'league' | 'organization'
  selectedRequiredDocumentIds: string[]
  setSelectedRequiredDocumentIds: (state: string[]) => void
}

const DocumentContent: React.FC<DocumentContentProps> = ({
  organizationId,
  referenceId,
  reference,
  selectedRequiredDocumentIds,
  setSelectedRequiredDocumentIds,
}) => {
  const {
    data: orgDocuments,
    isLoading: orgDocumentsLoading,
    isFetching: orgDocumentFetching,
    refetch: orgDocumentRefetch,
  } = useGetOrgDocuments(organizationId)

  useEffect(() => {
    orgDocumentRefetch()
  }, [organizationId])

  return (
    <div className="mt-10px">
      {orgDocumentsLoading || orgDocumentFetching ? (
        <div className="h-full flex justify-center align-center py-30px">
          <Spinner />
        </div>
      ) : (
        <div className="mt-10px">
          {orgDocuments.length > 0 ? (
            orgDocuments.map((doc: OrgDocumentResp) => {
              return (
                <div key={doc._id}>
                  <SelectDocument
                    data={doc}
                    organizationId={organizationId}
                    selectedDocs={selectedRequiredDocumentIds}
                    setSelectedDocs={setSelectedRequiredDocumentIds}
                  />
                </div>
              )
            })
          ) : (
            <div className="py-30px">
              <EmptyData message="no docs" />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default DocumentContent
